<div class="largeModelContainer">
  <div *ngIf="isLoading" class="notificationLoading svg-loader"></div>
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()">cancel</a>
  </div>
  <div class="modelTitle alignCenter heading2">
    Notifications
  </div>
  <div class="modelBody" id="modelBody">
    <div class="allNotification">
      <div class="notificationTimeline">
        <div class="timelineTitle">Today</div>
        <div *ngFor="let element of todaysNotification" [ngClass]="element.acknowledged ? 'read':'unread'">
          <ng-template [ngTemplateOutlet]="repeatedNotification"
                       [ngTemplateOutletContext]="{element:element}"></ng-template>
        </div>
        <div *ngIf="todaysNotification.length == 0" class="notifications"> No Notification</div>
      </div>
      <div class="notificationTimeline">
        <div class="timelineTitle">Yesterday</div>
        <div *ngFor="let element of yesterdaysNotification" [ngClass]="element.acknowledged ? 'read':'unread'">
          <ng-template [ngTemplateOutlet]="repeatedNotification"
                       [ngTemplateOutletContext]="{element:element}"></ng-template>
        </div>
        <div *ngIf="yesterdaysNotification.length == 0" class="notifications"> No Notification</div>
      </div>
      <div class="notificationTimeline">
        <div class="timelineTitle">Older</div>
        <div *ngFor="let element of olderNotification" [ngClass]="element.acknowledged ? 'read':'unread'">
          <ng-template [ngTemplateOutlet]="repeatedNotification"
                       [ngTemplateOutletContext]="{element:element}"></ng-template>
        </div>
        <div *ngIf="olderNotification.length == 0" class="notifications"> No Notification</div>
      </div>
    </div>
  </div>
</div>

<ng-template #repeatedNotification let-element='element'>
  <div class="notifications">
    <div class="notificationHeader">
      <div class="notificationSource">{{element.component}}</div>
      <div class="notificationTime">{{element.time  | date: 'yyyy-M-dd T HH:mm:ss'}}</div>
      <div class="clearfix"></div>
    </div>
    <div class="notificationDetails">
      {{element.notificationMessage}}
    </div>
  </div>
</ng-template>
